import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Button, ButtonProps, Stack, Typography } from '@mui/material';

import palette from '@/theme/palette.ts';

interface ActionButtonProps extends ButtonProps {
  label: string;
  actionType: 'CANCEL' | 'ACTION';
  plusIcon?: boolean;
}

export const ActionButton = ({ label, actionType, plusIcon, ...props }: ActionButtonProps) => {
  const buttonBackground =
    actionType === 'ACTION' ? palette.primary.main : palette.background.default;
  const textColor = actionType === 'ACTION' ? palette.text.contrast : palette.primary.main;
  return (
    <Button
      variant="contained"
      {...props}
      sx={{
        width: 'max-content',
        height: '42px',
        background: buttonBackground,
        border: `1px solid ${actionType === 'CANCEL' ? palette.primary.main : 'none'}`,
        ...props.sx,
      }}
    >
      <Stack
        direction="row"
        justifyContent="center"
        alignContent="center"
        sx={{ width: '100%', gap: `${plusIcon ? '6px' : '0'}` }}
      >
        {plusIcon && <AddIcon sx={{ color: palette.background.default }} />}
        <Typography
          variant="subtitle2"
          sx={{ color: textColor, fontSize: '15px', fontWeight: '500' }}
        >
          {label}
        </Typography>
      </Stack>
    </Button>
  );
};
